import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import TransitionPage from 'containers/TransitionPage'
import BackButton from 'components/atoms/buttons/BackButton'

import {isLoggedIn} from 'utils/session'

const styles = theme => ({
  root: {
    width: 328,
    margin: '0 auto',
    position: 'relative',
    ...theme.components.accountPage,
  },
  title: {
    fontSize: 32,
    fontWeight: 400,
    lineHeight: '39px',
    marginBottom: theme.spacing(2),
    fontColor: theme.palette.black,
  },
  backButton: {
    ...theme.components.backButton,
  },
})

class EmailSent extends React.PureComponent {
  onBackPress = () => {
    if (isLoggedIn()) {
      this.props.history.push('/account/home')
    } else {
      this.props.history.push('/login')
    }
  };

  render() {
    const { classes } = this.props

    return (
      <TransitionPage>
        <div className={classes.root}>
          <Typography className={classes.title}>
            We've sent you <br />
            an email!
          </Typography>
          <Typography>Follow the instructions we sent to continue</Typography>
          <BackButton
            className={classes.backButton}
            onPress={this.onBackPress}
          />
        </div>
      </TransitionPage>
    )
  }
}

EmailSent.propTypes = {
  history: PropTypes.object,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(EmailSent)



// WEBPACK FOOTER //
// ./src/containers/account/EmailSent/EmailSent.js